import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=sat-info-row><span class=sat-info-label>DEST</span><span class=sat-info-value>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=sat-info-row><span class=sat-info-label>ETA</span><span class=sat-info-value>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=ship-info-panel><div class="sat-info-header ship-info-header"><span class="sat-info-title ship-info-title"></span><button class=sat-info-close>✕</button></div><div class=sat-info-body><div class=sat-info-row><span class=sat-info-label>MMSI</span><a class="sat-info-value ship-info-link"target=_blank rel=noopener></a></div><div class=sat-info-row><span class=sat-info-label>TYPE</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>POSITION</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>SPEED</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>HEADING</span><span class=sat-info-value></span></div></div><div class="sat-info-footer ship-info-footer"><button class=sat-info-follow-btn></button><button class=sat-info-follow-btn style=margin-left:8px></button><a class=ship-info-external-link target=_blank rel=noopener>View on MarineTraffic ↗`);
/**
 * WorldView - Ship Info Panel (SolidJS)
 * Displays ship metadata when a ship is selected.
 * Port from src/ui/ship-info-panel.ts
 */

import { Show, createMemo } from "solid-js";
import { selection } from "../../stores/selection";
import { formatCoordinates, formatSpeedKn, formatHeading } from "../formatters";
import { useEntityPanel } from "./useEntityPanel";
import { toggleMaritimeFocus, maritimeFocusActive } from "../../stores/maritimeFocus";

/** Converts AIS ship type code to display text */
function shipTypeToDisplayText(shipType) {
  if (shipType >= 70 && shipType <= 79) return "Cargo Vessel";
  if (shipType >= 80 && shipType <= 89) return "Tanker";
  if (shipType >= 60 && shipType <= 69) return "Passenger Vessel";
  if (shipType === 30) return "Fishing Vessel";
  if (shipType >= 31 && shipType <= 35) return "Towing/Dredging";
  if (shipType >= 40 && shipType <= 49) return "High Speed Craft";
  if (shipType >= 50 && shipType <= 59) return "Special Craft";
  return "Vessel";
}

/**
 * ShipInfo component
 * Displays ship metadata when a ship is selected
 */
export function ShipInfo() {
  const {
    isFollowing,
    handleFollow,
    handleClose
  } = useEntityPanel("ship");
  const data = createMemo(() => {
    if (selection.type !== "ship") return null;
    return selection.data;
  });
  return _$createComponent(Show, {
    get when() {
      return data();
    },
    children: shipData => (() => {
      var _el$ = _tmpl$3(),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.firstChild,
        _el$4 = _el$3.nextSibling,
        _el$5 = _el$2.nextSibling,
        _el$6 = _el$5.firstChild,
        _el$7 = _el$6.firstChild,
        _el$8 = _el$7.nextSibling,
        _el$9 = _el$6.nextSibling,
        _el$0 = _el$9.firstChild,
        _el$1 = _el$0.nextSibling,
        _el$10 = _el$9.nextSibling,
        _el$11 = _el$10.firstChild,
        _el$12 = _el$11.nextSibling,
        _el$13 = _el$10.nextSibling,
        _el$14 = _el$13.firstChild,
        _el$15 = _el$14.nextSibling,
        _el$16 = _el$13.nextSibling,
        _el$17 = _el$16.firstChild,
        _el$18 = _el$17.nextSibling,
        _el$25 = _el$5.nextSibling,
        _el$26 = _el$25.firstChild,
        _el$27 = _el$26.nextSibling,
        _el$28 = _el$27.nextSibling;
      _$insert(_el$3, () => shipData().name || shipData().mmsi);
      _$addEventListener(_el$4, "click", handleClose, true);
      _$insert(_el$8, () => shipData().mmsi);
      _$insert(_el$1, () => shipTypeToDisplayText(shipData().shipType));
      _$insert(_el$12, (() => {
        var _c$ = _$memo(() => !!shipData().position);
        return () => _c$() ? formatCoordinates(shipData().position.lat, shipData().position.lng) : "—";
      })());
      _$insert(_el$15, () => formatSpeedKn(shipData().speed));
      _$insert(_el$18, () => formatHeading(shipData().heading));
      _$insert(_el$5, _$createComponent(Show, {
        get when() {
          return shipData().destination;
        },
        get children() {
          var _el$19 = _tmpl$(),
            _el$20 = _el$19.firstChild,
            _el$21 = _el$20.nextSibling;
          _$insert(_el$21, () => shipData().destination);
          return _el$19;
        }
      }), null);
      _$insert(_el$5, _$createComponent(Show, {
        get when() {
          return shipData().eta;
        },
        get children() {
          var _el$22 = _tmpl$2(),
            _el$23 = _el$22.firstChild,
            _el$24 = _el$23.nextSibling;
          _$insert(_el$24, () => shipData().eta);
          return _el$22;
        }
      }), null);
      _$addEventListener(_el$26, "click", handleFollow, true);
      _$insert(_el$26, () => isFollowing() ? "UNFOLLOW" : "FOLLOW");
      _$addEventListener(_el$27, "click", toggleMaritimeFocus, true);
      _$insert(_el$27, () => maritimeFocusActive() ? "EXIT FOCUS" : "SHIPS ONLY");
      _$effect(_p$ => {
        var _v$ = `https://myshiptracking.com/da/?mmsi=${shipData().mmsi}`,
          _v$2 = `https://www.marinetraffic.com/en/ais/details/ships/mmsi:${shipData().mmsi}`;
        _v$ !== _p$.e && _$setAttribute(_el$8, "href", _p$.e = _v$);
        _v$2 !== _p$.t && _$setAttribute(_el$28, "href", _p$.t = _v$2);
        return _p$;
      }, {
        e: undefined,
        t: undefined
      });
      return _el$;
    })()
  });
}
export default ShipInfo;
_$delegateEvents(["click"]);